module.exports = __webpack_public_path__ + "static/media/Bluelab Combo Meter with Leap pH Probe.924649ef.webp";